/**
 * PageHeader — universal page header.
 * Handles breadcrumb, title, action buttons, and warning bar slot.
 *
 * Usage:
 *   <PageHeader
 *     title="Sales"
 *     breadcrumb="Transactions"
 *     actions={<Button>Export</Button>}
 *     warningBar="3 unclosed business days — close before making a new sale."
 *   />
 */

import { AlertTriangle } from 'lucide-react';

export function PageHeader({
  title,
  breadcrumb,
  actions,
  warningBar,
  className = '',
}) {
  return (
    <div className={`mb-6 ${className}`}>
      {warningBar && (
        <div
          className="mb-3 flex items-center gap-2 rounded-lg px-4 py-2.5 text-[13px]"
          style={{
            backgroundColor: 'var(--warning-tint)',
            border: '1px solid var(--warning-bg)',
            color: 'var(--warning-text)',
          }}
        >
          <AlertTriangle size={14} className="flex-shrink-0" style={{ color: 'var(--warning-icon)' }} />
          {warningBar}
        </div>
      )}

      <div className="flex items-center justify-between gap-4">
        <div>
          {breadcrumb && (
            <nav
              className="text-[11px] font-semibold uppercase tracking-wide mb-1"
              style={{ color: 'var(--text-tertiary)' }}
            >
              {breadcrumb}
            </nav>
          )}
          <h1
            className="text-[24px] font-bold leading-tight"
            style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--text-primary)' }}
          >
            {title}
          </h1>
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
